export default __webpack_public_path__ + "img/marker-icon-3.svg";